module.exports = __webpack_public_path__ + "static/media/test-beginner.b1e68b41.png";